import styled from '@emotion/styled';

export const CardWithControlsWrapper = styled.div<{ isInactive: boolean; isListCard: boolean }>`
  position: relative;
  background: ${props => props.theme.colors.neutrals.white};
  transition: all .2s ease;
  border-radius: ${props => props.theme.borderRadius.tiny};
  width: 100%;
  margin-bottom: 16px;
  ${({ theme, isListCard }) => isListCard ? `
    border-radius: ${theme.borderRadius.small};
    border: 1px solid ${theme.colors.neutrals.grey8};
  ` : ''}

  .saved-list-card-buttons-wrapper {
    ${({ theme }) => `
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)};
      justify-content: space-between;
      left: 0;
      display: flex;
      border: none;
    `}
  }
  .saved-list-card-button {
    ${({ theme }) => theme.media.showAt({ from: 1, to: 2 })`
      z-index: 1;
    `}
  }

  ${({ theme }) => theme.media.showAt({ from: 1, isTouch: false })`
    padding-bottom: ${theme.spacing(7)};

    .tags-wrapper {
      min-height: 36px;
    }

    .universal-card-hover-show {
      display: none;
    }

    .universal-card-pager-hover {
      display: none;
    }
    &:hover {
      .tags-wrapper {
        visibility: hidden;
      }
      .saved-list-card-buttons-wrapper {
        display: flex;
        background-color: ${theme.colors.neutrals.white};
        border-radius: 0 0 ${theme.borderRadius.small} ${theme.borderRadius.small};
      }

      .saved-list-card-button {
        display: flex;
      }

      .universal-card-hover-show {
        display: flex;
      }

      .universal-card-pager-hover {
        display: flex;
      }

      &:before {
        opacity: 1;
      }
      box-shadow: ${theme.shadow.level1};
      & > div:first-of-type > div:last-of-type > div:not(:nth-of-type(2)) {
        opacity: 1;
      }
    }
  `}

  ${({ theme }) => theme.media.showAt({ from: 1, isTouch: true })`
    .saved-list-card-buttons-wrapper {
      display: flex;
      position: static;
      padding-top: 0;
      margin-top: 2px;
    }

    .saved-list-card-button {
      display: flex;
    }
  `}

${({ theme, isListCard }) => isListCard && theme.media.showAt({ at: 1 })`
    button {
      font-size: 15px;
    }
    .saved-listings-container > div {
      margin-right: 0;
    }
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    height: 333px;
  `}
`;

export const CardWithControlsWrapperPadding = styled.div<{ isListCard: boolean }>`
  padding: ${({ theme, isListCard }) => isListCard ? 0 : theme.spacing(1)};
  width: 100%;
  z-index: 2;
  > a {
    text-decoration: inherit;
  }
`;

export const CardWithControlsInactive = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  border-radius: ${props => props.theme.borderRadius.tiny};
  opacity: 0.5;
  z-index: 1;
`;

export const CardWithControlsButtonWrapper = styled.div`
  width: calc(50% - 5px);
  display: flex;

  > div {
    width: 100%;
  }
`;

export const CardWithControlsRemoveButtonWrapper = styled.div`
  width: 100%;
  z-index: 2;
`;

export const ControlsDiviwer = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.neutrals.grey8};
  margin: ${({ theme }) => `0 ${theme.spacing(1)} ${theme.spacing(1)}`};
`;
